import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

import { ConfigDto } from '../../../api';
import { NarwhalService } from '../../../narwhal.service';
import { GlobalService } from '../../../global.service';
import { InventoryItemDto } from '../../../api/inventoryItemDto';
import { NarwhalDto, Gender } from '../../../api/narwhalDto';

@Component({
	selector: 'narwhalia-apply-popup',
	templateUrl: './apply-popup.component.html',
	styleUrls: ['./apply-popup.component.scss'],
	// tslint:disable-next-line:use-host-property-decorator
	host: {
		'[class.isOverflowing]': 'isOverflowing'
	}
})
export class ApplyPopupComponent implements OnInit {
	@Input() narwhal: NarwhalDto;
	@Output() emitVisibility: EventEmitter<boolean>;
	@Output() refreshNarwhal: EventEmitter<InventoryItemDto[]>;
	inventory: InventoryItemDto[];
	config: ConfigDto;
	inventoryItemsToApply: InventoryItemDto[];
	total: any;
	totalKeys: any;
	isOverflowing: boolean;

	@HostListener('document:click', ['$event'])
	clickedOutside(event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.emitVisibility.emit(false);
		}
	}

	closeApplyPopup() {
		this.emitVisibility.emit(false);
	}

	constructor(private narwhalService: NarwhalService, private elementRef: ElementRef, private globalService: GlobalService) {
		this.globalService.config.subscribe(config => (this.config = config));
		this.emitVisibility = new EventEmitter();
		this.refreshNarwhal = new EventEmitter();
		this.inventoryItemsToApply = [];
	}

	ngOnInit() {
		this.narwhalService.inventoryItems$.subscribe((inventoryItems: InventoryItemDto[]) => {
			this.inventory = inventoryItems.map(inventoryItem => ({
				...inventoryItem,
				isShown: this.isInventoryItemApplicable(inventoryItem)
			}));
		});
		this.calculateOverflow();
	}

	applyImprovements() {
		this.narwhalService
			.applyImprovements(this.narwhal.id, [...this.inventoryItemsToApply.map(inventoryItem => inventoryItem.id)])
			.subscribe(() => {
				this.refreshNarwhal.emit(this.inventoryItemsToApply);
				this.closeApplyPopup();
			});
	}

	applyItem(inventoryItem, event) {
		if (event) {
			this.inventoryItemsToApply.push(inventoryItem);
		} else {
			const i = this.inventoryItemsToApply.indexOf(inventoryItem);
			if (i !== -1) {
				this.inventoryItemsToApply.splice(i, 1);
			}
		}
		this.calculateSum();
		this.refreshInventory();
	}

	private calculateSum() {
		const total = {
			Fitness: {
				percentage: 1,
				level: 0
			},
			Age: {
				percentage: 1,
				level: 0
			},
			Productivity: {
				percentage: 1,
				level: 0
			}
		};

		for (const invItem of this.inventoryItemsToApply) {
			for (const improvement of invItem.improvements) {
				const imprName = improvement.name;
				if (total[imprName].level + this.narwhal[`${imprName.toLowerCase()}Level`] + improvement.level <= 5) {
					total[imprName].percentage *= 1 + improvement.value / 100;
					total[imprName].level += improvement.level;
				}
			}
		}

		this.total = total;
		this.totalKeys = Object.keys(this.total);
	}

	private refreshInventory() {
		this.inventory = this.inventory.map(
			inventoryItem =>
				this.inventoryItemsToApply.some(i => i.id === inventoryItem.id)
					? inventoryItem
					: {
						...inventoryItem,
						isShown: this.isInventoryItemApplicable(inventoryItem, true)
					}
		);
	}

	private isInventoryItemApplicable = (inventoryItem: InventoryItemDto, addTotal = false) =>
		(inventoryItem.gender === this.narwhal.gender || !inventoryItem.gender
			|| inventoryItem.gender === Gender.Unisex) &&
		inventoryItem.improvements.some(improvement => {
			const narwhalImprLevel = this.narwhal[`${improvement.name.toLowerCase()}Level`];
			const narwhalFutureImprLevel = addTotal ? narwhalImprLevel + this.total[improvement.name].level : narwhalImprLevel;
			const improvementMaxLevel = this.config.maxLevels.find(maxLevel => maxLevel.propertyId === improvement.name[0]);
			return narwhalFutureImprLevel + improvement.level <= improvementMaxLevel.value;
		});

	private calculateOverflow() {
		const element = this.elementRef.nativeElement;
		const fullWidth = element.offsetLeft + element.clientWidth + element.parentElement.offsetLeft + element.parentElement.clientWidth;
		if (fullWidth - 30 > window.innerWidth) {
			this.isOverflowing = true;
		} else {
			this.isOverflowing = false;
		}
	}
}